import "./HotelWebsiteSEOBookingEngineOptimization.module.css";
import Header from "@/reusable_sections/Header";
import HotelHero from "./sections/HotelHero";
import RevenueImpact from "./sections/RevenueImpact";
import Services from "./sections/Services";
import Booking from "./sections/Booking";
import Benchmarks from "./sections/Benchmarks";
import Performance from "./sections/Performance";
import Faq from "./sections/Faq";
import Servicenavigation from "./sections/Servicenavigation";
import Footer from "@/reusable_sections/Footer";
export default function HotelWebsiteSEOBookingEngineOptimizationPage() {
  return <div>
      <Header />
      <HotelHero />
      <RevenueImpact />
      <Services />
      <Booking />
      <Benchmarks />
      <Performance />
      <Faq />
      <Servicenavigation />
      <Footer />
    </div>;
}